import { Validators } from '@angular/forms';
import { SampleType } from '@app/modules/service-data/types/sample.types';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';
import { errorValueValidator } from '@shared/validators/error-value-validator';

export const niptSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        sampleType: {
          validators: [errorValueValidator(SampleType.Saliva)],
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        gestationAge: {
          children: {
            day: {
              validators: [
                Validators.required,
                Validators.min(0),
                Validators.max(6),
              ],
            },
            week: {
              validators: [
                Validators.required,
                Validators.min(10),
                Validators.max(40),
              ],
            },
          },
        },
        priorScreeningTest: {
          children: {
            priorScreeningTestType: {
              validators: [Validators.required],
            },
          },
        },
        heparinTherapy: {
          children: {
            hasReceived: {
              validators: [Validators.required],
            },
            isRelevant: {
              validators: [errorValueValidator(true)],
            },
          },
        },
        patientHistory: {
          children: {
            albuminTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
            cellularImmunotherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
            stemCellTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            transplantSurgery: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            bloodTransfusion: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
          },
        },
      },
      validators: [
        crossFieldValidator(
          'patientHistory.bloodTransfusion.isRelevant',
          'patientHistory.bloodTransfusion.hasReceived',
          true
        ),
        crossFieldValidator(
          'patientHistory.cellularImmunotherapy.isRelevant',
          'patientHistory.cellularImmunotherapy.hasReceived',
          true
        ),
        crossFieldValidator(
          'patientHistory.albuminTherapy.isRelevant',
          'patientHistory.albuminTherapy.hasReceived',
          true
        ),
        crossFieldValidator(
          'heparinTherapy.isRelevant',
          'heparinTherapy.hasReceived',
          true
        ),
      ],
    },
    nipt: {
      children: {
        priorScreeningTest: {
          children: {
            priorScreeningTestType: {
              validators: [Validators.required],
            },
          },
        },
      },
    },
  },
};
